import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faFile } from "@fortawesome/free-solid-svg-icons";
import { Tooltip } from "@mui/material";

const IndividualFileInput = ({ id, label, codigoDocumento = 0, disabled, temArquivoInformado = false, register, registerName, onChange, fnBaixarDocumento }) => {
    return (
        <div className="upload_box_individual">
            <p style={{ marginBottom: "5px" }}>{ label }</p>
            <input 
                type="file" 
                readOnly={disabled}
                id={id} 
                className="upload_input" 
                {...register(registerName)} 
                disabled={disabled}
                onChange={onChange}
            />
            <div style={{display: "flex", width: "100%"}}>
                <label 
                    style={{ color: "#B8B8B8" }}
                    htmlFor={id} 
                    className={`upload_label_individual ${(temArquivoInformado  || codigoDocumento !== 0) ? 'uploaded_label' : ''}`}
                >
                    <div>
                        {temArquivoInformado || codigoDocumento !== 0 ? 
                            "Arquivo adicionado" : 
                            ((id === 0) ? 
                                "Selecione um arquivo" : 
                                "Início de instalação já informada. Carta não definida."
                            )
                        }
                    </div>
                </label>
                { (codigoDocumento !== 0) && (
                    <Tooltip title="Realizar download do documento" placement="right">
                        <button 
                            className="upload_button" 
                            onClick={fnBaixarDocumento}
                        >
                            <FontAwesomeIcon icon={faFile} />
                        </button>
                    </Tooltip>
                )}
            </div>
        </div>
    );
}

export default IndividualFileInput;